const routes = [
    {
        path: '/contabilidade/dominio_sistemas/integracoes_contas_bancarias/index/:hash',
        alias: ['/contabilidade/dominio_sistemas/integracoes_contas_bancarias/:hash'],
        component: () => import('../views/Listar'),
    },
]

export default routes
